import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BathroomIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BathroomIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.28175 11.423V6.7569C5.28175 5.56501 6.25154 4.59521 7.4439 4.59521C8.63579 4.59521 9.60558 5.56501 9.60558 6.7569V6.934H10.023C10.3614 6.934 10.6371 7.20877 10.6371 7.54767C10.6371 7.88657 10.3614 8.16132 10.023 8.16132H7.95991C7.62149 8.16132 7.34625 7.88657 7.34625 7.54767C7.34625 7.20877 7.62149 6.934 7.95991 6.934H8.37779V6.7569C8.37779 6.24185 7.95895 5.82254 7.4439 5.82254C6.92885 5.82254 6.51001 6.24186 6.51001 6.7569V11.423H5.28175Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.41173 11.3264V6.75751C6.41173 6.18857 6.87481 5.7257 7.444 5.7257C8.01294 5.7257 8.47581 6.18857 8.47581 6.75751V7.03267H7.96011C7.67517 7.03267 7.44417 7.26367 7.44417 7.54861C7.44417 7.83355 7.67517 8.06452 7.96011 8.06452H10.0231C10.308 8.06452 10.539 7.83356 10.539 7.54861C10.539 7.26366 10.308 7.03267 10.0231 7.03267H9.50766V6.75751C9.50766 5.6196 8.58191 4.69385 7.444 4.69385C6.30584 4.69385 5.37988 5.6196 5.37988 6.75751V11.3264H6.41173Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1719 19.7646C18.0968 19.7646 18.0211 19.7503 17.9479 19.7206L16.5942 19.1539C16.027 19.3252 15.3741 19.4095 14.7173 19.4095H10.1829C9.6262 19.4095 9.0719 19.3492 8.53435 19.2295L7.40852 19.7196C7.3348 19.7503 7.25917 19.7646 7.18307 19.7646C6.94613 19.7646 6.73456 19.6239 6.64409 19.4056C6.58378 19.262 6.5833 19.1031 6.64265 18.9586C6.69435 18.8322 6.78721 18.7298 6.90592 18.6656C4.27371 17.4038 2.58496 14.7376 2.58496 11.813C2.58496 11.4903 2.84727 11.228 3.1699 11.228H21.7304C22.0525 11.228 22.3148 11.4903 22.3148 11.813C22.3148 14.6362 20.7089 17.2612 18.2059 18.5613L18.3979 18.6417C18.5419 18.701 18.6539 18.814 18.7133 18.9586C18.7726 19.1031 18.7722 19.262 18.7119 19.4066C18.6209 19.6239 18.4089 19.7646 18.1719 19.7646ZM3.78021 12.397C4.07842 15.6825 6.87051 18.2415 10.1829 18.2415H14.7174C18.0298 18.2415 20.8214 15.6826 21.1191 12.397H3.78021Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.37988 11.3264L3.1701 11.3257C2.90151 11.3257 2.68359 11.5435 2.68359 11.8122C2.68359 14.867 4.51974 17.5006 7.14579 18.6685L6.99624 18.7311C6.74777 18.8348 6.63119 19.1198 6.73495 19.3677C6.81248 19.5543 6.99318 19.6667 7.1836 19.6667C7.24649 19.6667 7.30998 19.6546 7.371 19.629L8.55645 19.1335C9.08021 19.2499 9.62469 19.3118 10.1832 19.3118H14.7175C15.3792 19.3118 16.0207 19.2252 16.6324 19.0635L17.9851 19.629C18.0467 19.6546 18.1102 19.6667 18.1725 19.6667C18.3629 19.6667 18.5436 19.5542 18.6217 19.3677C18.7255 19.1198 18.6083 18.8348 18.3605 18.7311L17.971 18.5684C20.4817 17.3547 22.2171 14.7823 22.2171 11.8122C22.2171 11.5435 21.9992 11.3257 21.7306 11.3257H6.47274M14.7175 18.3386H10.1832C6.74778 18.3386 3.92397 15.6711 3.67431 12.2987H21.2258C20.9762 15.6712 18.1524 18.3386 14.7175 18.3386Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BathroomIcon;
